import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { IBookingRequest, IBookingResponse, IOfferAddToBookingRequest } from "../../Orchestrator/Types/Types/BookingTypes";
import { invalidateBookingInflight } from "./getBooking";

export async function postBooking(
    bookingRequest: IBookingRequest
): Promise<IApiResponse<IBookingResponse>> {
    // Construct the endpoint with the booking ID
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.postBooking}`;

    // Make the API request using the constructed endpoint and bookingRequest
    return await apiRequest<IBookingResponse>(endpoint, 'POST', {
        body: JSON.stringify(bookingRequest),
    });
}


export async function addOfferToBooking(
    bookingId: string,
    bookingRequest: IOfferAddToBookingRequest
): Promise<IApiResponse<IBookingResponse>> {
    // Construct the endpoint with the booking ID
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.addBookOfferToBookingAPI(bookingId)}`;

    // `return await` + finally, not a bare return: without the await the finally
    // runs at ISSUE time, before the offer is on the booking. Same rule as
    // postPreExchangeOperation.
    try {
        return await apiRequest<IBookingResponse>(endpoint, 'POST', {
            body: JSON.stringify(bookingRequest),
        });
    } finally {
        // The booking now holds a new offer and every caller reads it straight
        // back — confirmShuttle's refreshUntilBillable, AddReturnJourneyTo-
        // BookingAction, book-it-again. Without this eviction that read JOINS a
        // GET issued BEFORE the POST (the checkout page's own shuttle/Nol
        // hydration keeps one in flight) and resolves with the pre-add booking.
        // The receipt is then rebuilt from a snapshot that has no shuttle offer
        // in it: no shuttle row, and payment.total short by the shuttle fare,
        // with the POST having succeeded. See invalidateBookingInflight.
        invalidateBookingInflight(bookingId);
    }
}
